import queryString from "query-string";

export const queryStringToObject = (str, options = {}) =>
  queryString.parse(str, {
    arrayFormat: "bracket",
    ...options,
  });

export const objectToQueryString = (obj, options = {}) =>
  queryString.stringify(obj, {
    arrayFormat: "bracket",
    ...options,
  });
